/* Post-purchase claim mode.
 *
 * Reached from the "design your order" email as ?claim=<token>. The customer
 * has already paid for a specific variant, so size/type/frame come from the
 * order and are locked; only the design itself is theirs to choose. On save the
 * customizer calls SkylitClaim.complete() with the design order id, which
 * attaches it to the paid Shopify order server-side.
 *
 * State machine, all keyed off `active` (token present in the URL) rather
 * than `claim` (token confirmed pending) — a customer must never fall
 * through to a normal Shopify checkout while `?claim=` is present, whether
 * the claim turns out to be pending, already used, expired, or the lookup
 * itself fails. Sections MUST gate their add-to-cart on `active`, and only
 * treat it as a real "confirm this design" action when `usable` is also
 * true. `usable === false` while `active === true` covers three states a
 * section should render identically (CTA disabled, error surfaced):
 * still loading, blocked (claimed/expired/not_found), or the fetch failed.
 */
(function () {
  var API = 'https://admin.skylitstudio.co.uk';
  var token = new URLSearchParams(window.location.search).get('claim');

  window.SkylitClaim = {
    active: !!token,
    token: token,
    claim: null,
    usable: false,
    message: '',
    complete: function () { return Promise.reject(new Error('This design link is not ready yet.')); },
  };
  if (!token) return;

  var bannerEl = null;
  function banner(text, tone) {
    if (!bannerEl) {
      bannerEl = document.createElement('div');
      bannerEl.className = 'skylit-claim-banner';
      bannerEl.setAttribute('role', 'status');
      document.body.insertBefore(bannerEl, document.body.firstChild);
    }
    bannerEl.style.cssText =
      'position:sticky;top:0;z-index:9999;padding:12px 16px;text-align:center;font-size:14px;' +
      (tone === 'error' ? 'background:#fdecea;color:#8a2018;' : 'background:#f0ece6;color:#3a2a1a;');
    bannerEl.textContent = text;
  }

  function setCtaLabel(label) {
    document.querySelectorAll('[data-claim-cta]').forEach(function (btn) {
      btn.disabled = true;
      btn.setAttribute('aria-disabled', 'true');
      // Some CTAs (moon's shared customizer-footer.liquid button) keep their
      // label in a child element (e.g. .cust-footer-btn-label) rather than
      // as the button's own text — `btn.textContent = label` would wipe
      // that child out entirely. The owning section's own JS then keeps
      // writing to a selector that no longer exists (e.g. moon-myjs.js's
      // `$btn.find(".cust-footer-btn-label").text(...)`), a silent no-op
      // that leaves the CTA permanently frozen on this driver's last label
      // with no way to ever re-enable it. Prefer writing into a known
      // label child when one exists; only fall back to replacing the
      // button's own text when it doesn't.
      var labelEl = btn.querySelector('.cust-footer-btn-label');
      if (labelEl) { labelEl.textContent = label; } else { btn.textContent = label; }
    });
  }

  // Anything the paid order didn't cover (gift wrap etc.) — the claim
  // short-circuit never reaches the normal cart/line-item logic, so a
  // choice made here would be silently discarded. Hide it outright rather
  // than let it be picked. Generic belt-and-suspenders; sections with their
  // own step/tab bookkeeping (e.g. name-landsat's guided flow) additionally
  // remove it from their own navigation arrays.
  function hideUnhonoured() {
    document.querySelectorAll('[data-claim-hide]').forEach(function (el) {
      el.setAttribute('hidden', 'hidden');
      el.style.display = 'none';
    });
  }

  // Fail closed immediately, before we even know whether the token is
  // valid: disable the CTA and hide anything we won't honour. Sections'
  // own control-locking (size/type/frame) happens on their side once their
  // pickers exist — see the `active`-gated lock in each section's JS.
  window.SkylitClaim.message = 'Loading your order…';
  setCtaLabel('Loading your order…');
  hideUnhonoured();

  function block(message, ctaLabel) {
    window.SkylitClaim.usable = false;
    window.SkylitClaim.claim = null;
    window.SkylitClaim.message = message;
    window.SkylitClaim.complete = function () {
      return Promise.reject(new Error('This design link cannot be used.'));
    };
    banner(message, 'error');
    setCtaLabel(ctaLabel || 'Unavailable');
  }

  fetch(API + '/api/design-claim/' + encodeURIComponent(token))
    .then(function (r) { return r.json(); })
    .then(function (claim) {
      if (claim.status === 'claimed') {
        block('This order has already been designed. Contact us if you need a change.');
        return;
      }
      if (claim.status !== 'pending') {
        block('This design link is no longer active. Please contact hello@skylitstudio.co.uk.');
        return;
      }

      window.SkylitClaim.claim = claim;
      window.SkylitClaim.usable = true;
      window.SkylitClaim.message = '';
      var who = claim.customer_name ? claim.customer_name + ', y' : 'Y';
      banner(who + 'our order ' + (claim.order_name || '') + ' is ready to personalise — the size and frame are already set from your order.');

      // Let the customizer's own JS pre-select the paid format/size/frame
      // and lock its controls now that the claim is confirmed usable.
      document.dispatchEvent(new CustomEvent('skylit:claim-ready', { detail: claim }));

      window.SkylitClaim.complete = function (designOrderId) {
        return fetch(API + '/api/design-claim/' + encodeURIComponent(token) + '/claim', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ order_id: designOrderId }),
        }).then(function (r) {
          if (!r.ok) throw new Error('claim failed: ' + r.status);
          window.location.href = '/pages/design-confirmed';
        });
      };
    })
    .catch(function (e) {
      console.error('[claim] lookup failed', e);
      block('We could not load your order. Please contact hello@skylitstudio.co.uk.');
    });
})();
